export enum EventType {

    PROJECT_EVENT               = 1,
    PROJECT_MILESTONE           = 2,
    PROJECT_DEADLINE            = 3,
    PROJECT_CREATED             = 4,
    PROJECT_PAYMENT             = 5,

    COMPANY_EVENT               = 10,
    COMPANY_HOLIDAY             = 11,

    PERSONAL_PAID_VACATION      = 20,
    PERSONAL_NON_PAID_VACATION  = 21,
    PERSONAL_SICK_LEAVE         = 22,
    PERSONAL_TRAVEL             = 24,
    PERSONAL_EXTRA_WORK_DAY     = 23,

    TASK_DEADLINE               = 30,
    TASK_SCHEDULE               = 31,
    TASK_START_END              = 32,

    MEETING                     = 40,

    WORKDAY= 0,     // this is just for client app not really events but used in user calendar (hr)
    WEEKEND= 90     // this is just for client app not really events but used in user calendar (hr)

}

type EventTypeObject = {
    type            : EventType,
    name            : string    // name used in add event
    label           : string
    icon            : string
    iconSvg         : string    // used in add evnet etc
    description     : string
}

export const ProjectEvent:EventTypeObject = {
    type        : EventType.PROJECT_EVENT,
    name        : 'Project event',
    label       : 'Project event',
    icon        : 'i5-event-project-event',
    iconSvg     : 'isvg-project-event',
    description : 'A generic project event which may span several days'
}

export const ProjectMilestone:EventTypeObject = {
    type    : EventType.PROJECT_MILESTONE,
    name   : 'Project milestone',
    label   : 'Project milestone',
    icon    : 'i5-milestone',
    iconSvg     : 'isvg-milestone',
    description : 'An important project deliverable or progress point'
}

export const ProjectDeadline:EventTypeObject = {
    type    : EventType.PROJECT_DEADLINE,
    name   : 'Project deadline',
    label   : 'Project deadline',
    icon    : 'i5-event-project-deadline',
    iconSvg     : 'isvg-project-event',
    description : ''
}

export const CompanyHoliday:EventTypeObject = {
    type        : EventType.COMPANY_HOLIDAY,
    name        : 'Holiday',
    label       : 'Holiday',
    icon        : 'i5-event-company-holiday',
    iconSvg     : 'isvg-holiday',
    description : 'Statutory holiday, company-wide day off or holiday break'
}

export const CompanyEvent:EventTypeObject = {
    type    : EventType.COMPANY_EVENT,
    name   : 'Organization event',
    label   : 'Organization event',
    icon    : 'i5-organization',
    iconSvg     : 'isvg-org-event',
    description : 'A company event that is important to all team members'
}

export const PersonalVacation:EventTypeObject = {
    type        : EventType.PERSONAL_PAID_VACATION,
    name        : 'Vacation',
    label       : 'Vacation',
    icon        : 'i5-event-personal-vacation',
    iconSvg     : 'isvg-vacation',
    description : 'Personal vacation time'
}

export const PersonalSickLeave:EventTypeObject = {
    type        : EventType.PERSONAL_SICK_LEAVE,
    name        : 'Sick leave',
    label       : 'Sick leave',
    icon        : 'i5-event-personal-sick-leave',
    iconSvg     : 'isvg-sick-leave',
    description : 'Time away from work due to illness'
}

export const PersonalTravel:EventTypeObject = {
    type        : EventType.PERSONAL_TRAVEL,
    name       : 'Travel',
    label       : 'Travel',
    icon        : 'i5-event-personal-travel',
    iconSvg     : 'isvg-travel',
    description : 'Time away from work due to business travel'
}


export class EventTypeClass {

    static toOption(eventType:EventTypeObject):Option {
        return {
            value   : eventType.type,
            label   : eventType.label,
            icon    : eventType.icon
        }
    }
}


export const ConstEvents = {

    type: {

        PROJECT_EVENT: 1,
        PROJECT_MILESTONE: 2,
        PROJECT_DEADLINE: 3,
        PROJECT_CREATED: 4,
        PROJECT_PAYMENT: 5,

        COMPANY_EVENT: 10,
        COMPANY_HOLIDAY: 11,

        PERSONAL_PAID_VACATION: 20,
        PERSONAL_NON_PAID_VACATION: 21,
        PERSONAL_SICK_LEAVE: 22,
        PERSONAL_TRAVEL: 24,
        PERSONAL_EXTRA_WORK_DAY: 23,

        TASK_DEADLINE                   : 30,
        TASK_SCHEDULE                   : 31,
        TASK_START_END                  : 32,

        MEETING                         : 40,

        WORKDAY: 0,     // this is just for client app not really events but used in user calendar (hr)
        WEEKEND: 90     // this is just for client app not really events but used in user calendar (hr)
    },

    singleDayTypes  : [2,3,4,5,23,30,31,40],

    projectTypes:   [1,2,3,4,5],
    companyTypes:   [10,11],
    personalTypes:  [20,21,22,23,24],
    taskTypes:      [30,31,32],
    meetingTypes:   [40],

    1: ProjectEvent,
    // 1: { name: 'Project event',         icon: 'i5-event-project-event',        description: 'A generic project event which may span several days' },

    2: ProjectMilestone,
    // 2: { name: 'Project milestone',     icon: 'i5-milestone',    description: 'An important project deliverable or progress point' },

    3: { name: 'Project deadline',      icon: 'i5-event-project-deadline',     description: 'Project deadline' },
    4: { name: 'Project created',       icon: 'i5-event-project-created',      description: 'Project created' },
    5: { name: 'Project payment',       icon: '',                                   description: 'Payment milestone' },

    10: CompanyEvent,
    // 10: { name: 'Organization event',   icon: 'i5-organization',               description: 'A company event that is important to all team members' },

    11: CompanyHoliday,
    // 11: { name: 'Holiday',              icon: 'i5-event-company-holiday',      description: 'Statutory holiday, company-wide day off or holiday break' },

    20: PersonalVacation,
    // 20: { name: 'Vacation',             icon: 'i5-event-personal-vacation',    description: 'Personal vacation time' },
    22: PersonalSickLeave,
    // 22: { name: 'Sick leave',           icon: 'i5-event-personal-sick-leave',  description: 'Time away from work due to illness' },
    24: PersonalTravel,
    // 24: { name: 'Travel',               icon: 'i5-event-personal-travel',      description: 'Time away from work due to business travel' },

    30: { name: 'Task deadline',        icon: 'i5-event-project-deadline',     description: 'Task due date / deadline' },
    31: { name: 'Task schedule',        icon: 'i5-event-project-deadline',     description: 'Task schedule' },
    32: { name: 'Task start/end',       icon: 'i5-event-project-deadline',     description: 'Task start / end' },

    40: { name: 'Meeting',              icon: 'i5-meeting',                   description: 'Meeting' },


    typeList: {
        1: 'Project / Event',
        2: 'Project / Milestone',
        3: 'Project / Deadline',
        4: 'Project / Created',
        5: 'Project / Payment',

        10: 'Organization / Event',
        11: 'Organization / Holiday',

        20: 'Personal / Vacation', // Paid vacation
        21: 'Personal / Non paid vacation',
        22: 'Personal / Sick leave',
        24: 'Personal / Travel',
        23: 'Personal / Extra workday',

        30: 'Task Deadline'
    },

    exportToOptions(arrEventTypes:any[]) {
        return arrEventTypes.map(function(eventType){
            return {
                value: eventType,
                label: gd.const.event.typeList[eventType]
            };
        });
    }


};